import { NftReference } from 't2-graphql-types';
import { useLazyQuery } from '@apollo/client';
import { getNftReferencesByArticleIdQuery } from '../queries/getArticleNftReferencesQuery';

type TQueryVariables = {
  articleId: string;
};

type TQueryResponse = {
  nftReferences: NftReference[];
};

export const useLazyArticleNftReferencesQuery = ({ articleId }: TQueryVariables) =>
  useLazyQuery<TQueryResponse, TQueryVariables>(getNftReferencesByArticleIdQuery, { variables: { articleId } });
